import {
	isEnabledBacktest,
	isEnabledChat,
	isEnabledDriftForecast,
	isEnabledEarningsAnalysis,
	isEnabledElements,
	isEnabledHolders,
	isEnabledQuote,
} from "@/lib/utils/features";
import { getAuthService } from "@/services/user-auth/auth-factory";
import type { UserRole } from "@/services/user-auth/user-roles";
import type { ViewId } from "@/shared/types/common";
import type { MenuItem } from "../MenuItemTypes";

export const menuItems = (roles: UserRole[] | null): MenuItem[] => {
	const authService = getAuthService(roles);
	return [
		// bronze
		{
			viewId: "Markets",
			text: "Markets",
			isEnabledByUserRole: authService.allowedWidgets.includes("Markets"),
		},
		...(isEnabledQuote()
			? [
					{
						viewId: "Quote" as ViewId,
						text: "Quote",
						isEnabledByUserRole: authService.allowedWidgets.includes("Quote"),
					},
				]
			: []),
		{
			viewId: "Chart",
			text: "Chart",
			isEnabledByUserRole: authService.allowedWidgets.includes("Chart"),
		},
		// silver
		{
			viewId: "Monitor",
			text: "Monitor",
			isEnabledByUserRole: authService.allowedWidgets.includes("Monitor"),
		},
		{
			viewId: "Screener",
			text: "Screener",
			isEnabledByUserRole: authService.allowedWidgets.includes("Screener"),
		},
		{
			viewId: "News",
			text: "News",
			isEnabledByUserRole: authService.allowedWidgets.includes("News"),
		},
		{
			viewId: "Financials",
			text: "Financials",
			isEnabledByUserRole: authService.allowedWidgets.includes("Financials"),
		},
		...(isEnabledQuote()
			? [
					{
						viewId: "Advanced Quote" as ViewId,
						text: "Advanced Quote",
						isEnabledByUserRole:
							authService.allowedWidgets.includes("Advanced Quote"),
					},
				]
			: []),
		...(isEnabledChat()
			? [
					{
						viewId: "Chat" as ViewId,
						text: "Chat",
						isEnabledByUserRole: authService.allowedWidgets.includes("Chat"),
					},
				]
			: [
					{
						viewId: "Chat" as ViewId,
						text: "Chat (coming soon)",
						disabled: true,
						isEnabledByUserRole: authService.allowedWidgets.includes("Chat"),
					},
				]),
		// gold
		...(isEnabledHolders()
			? [
					{
						viewId: "Holders" as ViewId,
						text: "Holders",
						isEnabledByUserRole: authService.allowedWidgets.includes("Holders"),
					},
				]
			: []),
		...(isEnabledEarningsAnalysis()
			? [
					{
						viewId: "Earnings Analysis" as ViewId,
						text: "Earnings Analysis",
						isEnabledByUserRole:
							authService.allowedWidgets.includes("Earnings Analysis"),
					},
				]
			: []),
		...(isEnabledDriftForecast()
			? [
					{
						viewId: "Drift Forecast" as ViewId,
						text: "Drift Forecast",
						isEnabledByUserRole:
							authService.allowedWidgets.includes("Drift Forecast"),
					},
				]
			: []),
		...(isEnabledElements()
			? [
					{
						viewId: "Elements" as ViewId,
						text: "Elements",
						isEnabledByUserRole:
							authService.allowedWidgets.includes("Elements"),
					},
				]
			: []),
		{
			viewId: "Dark Short",
			text: "Dark Short (coming soon)",
			isEnabledByUserRole: authService.allowedWidgets.includes("Dark Short"),
		},
		{
			viewId: "Holdings",
			text: "Holdings (coming soon)",
			isEnabledByUserRole: authService.allowedWidgets.includes("Holdings"),
		},
		{
			viewId: "Insiders",
			text: "Insiders (coming soon)",
			isEnabledByUserRole: authService.allowedWidgets.includes("Insiders"),
		},
		...(isEnabledBacktest()
			? [
					{
						viewId: "Backtest" as ViewId,
						text: "Backtest (coming soon)",
						isEnabledByUserRole:
							authService.allowedWidgets.includes("Backtest"),
					},
				]
			: []),
	];
};
